import React from 'react';
import { RichText } from 'prismic-reactjs';
import styled from 'styled-components';

const Container = styled.div`
  min-width: 380px;
  width: 100%;
  padding: 0 16px;
  border-left: 1px solid #979797;
  height: 515px;
  display: flex;
  flex-wrap: wrap;
  p {
    min-height: 100px;
  }
  strong {
    display: block;
    font: bold italic 28px 'Times new roman';
    color: #000;
    width: 100%;
  }
  img {
    width: 100%;
  }
`

const HistoryItem = ({ano, texto, imagem}) => {
  return (
    <Container>
      <strong>{ ano }</strong>
      { RichText.render(texto) }
      <img alt={ ano } src={ imagem.url } />
    </Container>
  )
}

export default HistoryItem;
